module.exports = __webpack_public_path__ + "media/images/emblems/Leytron-coat_of_arms-b5b4752ce345fe83d2b73ef4e6c4715f.svg";